<template>
  <icon-button :button-text="i18n.t('components.trix_editor.toolbar.bold')" icon-key="bold"
               data-trix-attribute="bold" data-trix-key="b" />
</template>

<script>
import IconButton from './icon-button'

export default {
  components: { IconButton }
}
</script>
